<template>
    <CCard>
      <CCardHeader>
        <slot name="header">
          Team Confirmation Report
        </slot>
      </CCardHeader>
      <CCardBody>
        <CDataTable
        :items="this.$store.state.teamAdminList.playerConfirmation"
        :fields="[{key:'club_id', label:'Club'}, {key:'player_id', label:'id'}, {key:'last_name', label:'Player'}, {key:'team_name', label:'Team'}, {key:'position', label:'Pos'}, {key:'status', label:'Status'}]"
        sorter
        hover
        striped
        bordered
        small
        fixed
    >
        <template #club_id="{item}">
        <td>
            {{getClubName(item.club_id)}}
        </td>
        </template>
        </CDataTable>
      </CCardBody>
    </CCard>
</template>
<script>

export default {
  name: 'TeamConfirmationReport',
  created() {
    this.$store.dispatch("loadAllPlayerConfirmations", {clubId:"99"});
  },
  methods: {
    getClubName: function(clubid) {
        return this.$store.state.clubs[clubid].manager;
    }
  }
}
</script>